"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
ContactController.$inject = [];
function ContactController() {
}
exports.ContactController = ContactController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/contact/controllers/ContactController.js
// module id = 448
// module chunks = 0